import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import WasteType from '../entities/wastetype'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface WasteTypeState extends ListState<WasteType>{
    editWasteType:WasteType;
}
class WasteTypeModule extends ListModule<WasteTypeState,any,WasteType>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<WasteType>(),
        loading:false,
        editWasteType:new WasteType()
    }
    actions={
        async getAll(context:ActionContext<WasteTypeState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/WasteType/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<WasteType>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<WasteTypeState,any>,payload:any){
            await Ajax.post('/api/services/app/WasteType/Create',payload.data);
        },
        async update(context:ActionContext<WasteTypeState,any>,payload:any){
            await Ajax.put('/api/services/app/WasteType/Update',payload.data);
        },
        async delete(context:ActionContext<WasteTypeState,any>,payload:any){
            await Ajax.delete('/api/services/app/WasteType/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<WasteTypeState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/WasteType/Get?Id='+payload.id);
            return reponse.data.result as WasteType;
        }
    };
    mutations={
        setCurrentPage(state:WasteTypeState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:WasteTypeState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:WasteTypeState,wastetype:WasteType){
            state.editWasteType=wastetype;
        }
    }
}
const wastetypeModule=new WasteTypeModule();
export default wastetypeModule;